import React from 'react';
import { useEffect, useState } from 'react';

const MeetingIndex = () => {
  const initialize = async () => {
    const { ZoomMtg } = await import('@zoomus/websdk');
    ZoomMtg.setZoomJSLib('https://source.zoom.us/2.13.0/lib', '/av');

    ZoomMtg.preLoadWasm();
    ZoomMtg.prepareWebSDK();
    // loads language files, also passes any error messages to the ui
    ZoomMtg.i18n.load('en-US');
    ZoomMtg.i18n.reload('en-US');
    var authEndpoint = 'http://localhost:4000';
    var sdkKey = 'vUk4wK8cRJSaRIgJTdMUFg';
    var meetingNumber = '72740401185';
    var passWord = '';
    var role = 0;
    var userName = 'React';
    var userEmail = '';
    var registrantToken = '';
    var zakToken = '';
    var leaveUrl = 'http://localhost:3000';

    function getSignature(e) {
      e.preventDefault();

      fetch(authEndpoint, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          meetingNumber: meetingNumber,
          role: role,
        }),
      })
        .then((res) => res.json())
        .then((response) => {
          startMeeting(response.signature);
        })
        .catch((error) => {
          console.error(error);
        });
    }

    function startMeeting(signature) {
      document.getElementById('zmmtg-root').style.display = 'block';

      ZoomMtg.init({
        leaveUrl: leaveUrl,
        success: (success) => {
          console.log(success);

          ZoomMtg.join({
            signature: signature,
            sdkKey: sdkKey,
            meetingNumber: meetingNumber,
            passWord: passWord,
            userName: userName,
            userEmail: userEmail,
            tk: registrantToken,
            zak: zakToken,
            success: (success) => {
              console.log(success);
            },
            error: (error) => {
              console.log(error);
            },
          });
        },
        error: (error) => {
          console.log(error);
        },
      });
    }
  };

  // useEffect(() => {
  //   initialize();
  // }, []);

  return (
    <div className='App'>
      <main>
        <h1>Live Class</h1>

        <button onClick={initialize}>Join Meeting</button>
      </main>
    </div>
  );
};

export default MeetingIndex;
